import { makeStyles } from '@material-ui/core';

export const loginPageStyles = makeStyles(() => ({
  heading10: {
    fontFamily: ['Mukta'].join(','),
  },
  headings: {
    fontFamily: ['Mulish'].join(','),
    left: 'calc(-50 % + 15px)',
    right: 'calc(50 % + 15px)',
  },
  heading: {
    fontFamily: ['Mulish'].join(','),
  },
  textFiled: {
    minWidth: '320px !important',
    maxWidth: '320px !important',
    width: '320px !important',
    '& .MuiFormHelperText-root ': {
      marginLeft: '4 !important',
      fontFamily: 'Mulish',
      fontWeight: 400,
      fontSize: 13,
      lineHeight: 16,
    },
  },
  notFoundSubHeading: {
    '&.MuiStepLabel-label-root': {
      fontSize: '30px !important',
      fontWeight: '700 !important',
    },
    boxDisplayNone: {
      display: 'none',
    },
  },

  buttonStyle: {
    fontSize: '19px !important',
    fontWeight: '700 !important',
    lineHeight: '25px !important',
    fontFamily: 'Mukta !important',
    width: '100% !important',
    borderRadius: '8px !important',
    color: 'white !important',
  },

  textField: {
    '& .MuiInputBase-input': {
      padding: '8px',
    },

    '& .MuiOutlinedInput-root': {
      fontFamily: 'Mulish',
      fontWeight: '400',
      fontSize: '17px',
      lineHeight: '21px',
      '&.Mui-focused fieldset': {
        border: '2px solid#1976d2 !important',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#DAE0EB !important',
    },
  },
}));
